<template>
  <div
    class="match"
    ref="matchrow">
    <router-link
      class="match-info"
      v-if="isVisible"
      tag="div"
      :to="{ name: 'EventView', params: { id: match.id, topOffer: topOffer } }">
      <div class="match-date-time">
        {{ matchTimeFormatted }}
      </div>
      <div class="match-name">
        <div
          class="team-name"
          v-for="team in match.teams"
          :key="team.id">
          {{ team.name }}
        </div>
      </div>
    </router-link>
    <div
      class="bets"
      v-if="betsVisible"
      :class="{ disabled: betsDisabled }">
      <bet
        v-for="bet in match.bets"
        :top-offer="topOffer"
        :key="bet.id"
        :match="match"
        :bet="bet"/>
    </div>
    <router-link
      class="more-bets"
      v-if="isVisible"
      :to="{ name: 'EventView', params: { id: match.id } }">
      +{{ match.totalBets }}
    </router-link>
  </div>
</template>

<script>
import Bet from './Bet.vue';

export default {
  data() {
    return {
      isVisible: false,
      observer: null,
    };
  },
  props: {
    match: {
      type: Object,
      required: true,
      default: () => {},
    },
    topOffer: {
      type: Number,
      required: true,
    },
  },
  components: {
    Bet,
  },
  computed: {
    sport() {
      return this.$store.getters.getSportById(this.match.idSport);
    },
    tournament() {
      return this.$store.getters.getTournamentById(this.match.idTournament);
    },
    category() {
      return this.$store.getters.getCategoryById(this.match.idCategory);
    },
    matchTimeFormatted() {
      const { time } = this.$options.filters;
      return this.topOffer
        ? time(this.match.timestampUTC, 'dddd, DD.M, HH:mm').toUpperCase()
        : time(this.match.timestampUTC, 'dddd, HH:mm').toUpperCase();
    },
    betsVisible() {
      return !_.isEmpty(this.match.bets) && this.isVisible;
    },
    betsDisabled() {
      return (this.sport && !this.sport.active)
          || (this.tournament && !this.tournament.active)
          || (this.category && !this.category.active)
          || !this.match.active;
    },
  },
  mounted() {
    const options = {
      root: null,
      threshold: 0.001,
    };
    this.observer = new IntersectionObserver((entries) => {
      _.each(entries, (entry) => {
        this.isVisible = entry.isIntersecting;
      });
    }, options);
    this.observer.observe(this.$refs.matchrow);
  },
  destroyed() {
    this.observer.disconnect();
  },
};
</script>

<style lang="scss" scoped>
  .match {
    position: relative;
    overflow: hidden;
    width: 100%;
    height: 100%;
    float: left;
  }

  .match-info {
    width: 25%;
    float: left;
    padding: 8px 5px;
    border-right: 4px solid #171717;
    height: 65px;
  }

  .match-date-time {
    color: #ffb300;
    font-size: 12px;
  }

  .match-name {
    padding-top: 5px;
  }

  .team-name {
    padding: 1px 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 18px;
  }

  .bets {
    position: relative;
    overflow: hidden;
    width: 70%;
    float: left;

    &.disabled:after {
      background: rgba(#000, 0.25);
      position: absolute;
      text-align: center;
      top: 5px;
      right: 0;
      bottom: 5px;
      left: 0;
      content: "\e6b7";
      font-family: NFont;
      font-size: 30px;
      line-height: 60px;
    }
  }
</style>
